import {Component, OnInit} from '@angular/core';
import {DataObjComponent, DataObjComponentHelper} from '../rest-service';
import {TariffClass, TariffClassService} from '../tariff-class.service';
import {Router} from '@angular/router';
import {NotificationService} from '../notification.service';
import {UserService} from '../user.service';

@Component({
  selector: 'app-tariff-class',
  templateUrl: './tariff-class.component.html',
  styleUrls: ['./tariff-class.component.css']
})
export class TariffClassComponent implements OnInit, DataObjComponent<TariffClass> {

  readonly namePlural = 'Tarifas';

  readonly editPath = '/tariff_class/';

  readonly newPath = '/tariff_class_new';

  helper: DataObjComponentHelper<TariffClass>;

  constructor(private service: TariffClassService, private router: Router, private ns: NotificationService, private us: UserService) {
    this.helper = new DataObjComponentHelper<TariffClass>(this.service, ns, this.us, this.router, this.editPath);
  }

  ngOnInit() {
    this.helper.onInit();
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/tariff-class/tariff-class.component.ts